import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'ct-lib-table-search-input, app-table-search-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FontAwesomeModule, TranslocoPipe, ReactiveFormsModule],
  template: `
    <div class="row search-input-wrapper">
      <div class="col-12 form-group icon-start m-0">
        <fa-icon [icon]="searchIcon"></fa-icon>
        <input
          type="text"
          class="form-control auto-height"
          [formControl]="control()"
          [placeholder]="placeholder() | transloco"
          [attr.aria-label]="placeholder() | transloco"
        />
      </div>
    </div>
  `,
  styles: `
    :host {
      flex: 1 1 0;
    }

    .search-input-wrapper {
      fa-icon {
        left: 0.5rem !important;
      }

      .form-control {
        border: none;
        padding-left: 2rem;
      }
    }
  `,
})
export class TableSearchInputComponent {
  readonly searchIcon = faSearch;

  readonly control = input<FormControl<string | null>>(
    new FormControl<string | null>(null)
  );
  readonly placeholder = input(
    'ct-library.snippets.table-search-input.placeholder'
  );
  readonly search = output<string | null>();

  constructor() {
    effect((onCleanup) => {
      const subscription = this.control()
        .valueChanges.pipe(debounceTime(500), distinctUntilChanged())
        .subscribe((value) => {
          this.search.emit(value === '' || value == null ? null : value);
        });
      onCleanup(() => subscription.unsubscribe());
    });
  }
}
